import api from "../_api";

const show = async ({ commit }, id) => {
  const result = await api.show(id);
  commit("STORE", result);
};

const index = async ({ commit }, query) => {
  const result = await api.index(query);
  commit("STORE_MANY", result);
};

const destroy = async ({ commit }, id) => {
  const result = await api.destroy(id);
  commit("DESTROY", result);
};

const store = async ({ commit }, body) => {
  const result = await api.store(body);
  commit("STORE", result);
};

const update = async ({ commit }, id, body) => {
  const result = await api.update(id, body);
  commit("STORE", result);
};

export default {
  update,
  store,
  destroy,
  index,
  show
};
